import React, { useEffect, useRef, useState } from 'react';
import { Teams, WhiteCircles } from '../../assets';
import { TAB_ITEMS } from './exports';
import { Modal } from 'antd';
import { SubscribeSectionEmbedded } from '../NewsLetter/SubscribeSection';

export default function TabScreen() {
  const SegmentLabels = TAB_ITEMS.map((item) => item.label);
  const [activeTab, setActiveTab] = React.useState(SegmentLabels[0]);

  const sectionRef = useRef(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [hasOpenedOnce, setHasOpenedOnce] = useState(false);

  const COOLDOWN_DAYS = 7;
  const STORAGE_KEY = 'subscribeModalClosedAt';

  const checkCooldown = () => {
    const lastClosed = localStorage.getItem(STORAGE_KEY);
    if (!lastClosed) return true;
    const daysPassed = (Date.now() - parseInt(lastClosed, 10)) / (1000 * 60 * 60 * 24);
    return daysPassed >= COOLDOWN_DAYS;
  };

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || hasOpenedOnce) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (isVisible && checkCooldown()) {
        setModalVisible(true);
        setHasOpenedOnce(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasOpenedOnce]);

  return (
    <>
      <div ref={sectionRef} id="subscribe-section">
        <Modal
          open={modalVisible}
          footer={null}
          onCancel={() => {
            setModalVisible(false);
            localStorage.setItem(STORAGE_KEY, Date.now().toString());
          }}
          centered
          className="subscribe-modal"
          zIndex={2000}
        >
          <SubscribeSectionEmbedded showExtraContent={false} />
        </Modal>
      </div>
      <section
        className="screenshot-screen-container"
        style={{
          backgroundColor: '#ffffff',
        }}
        id="ai_driven_apps"
      >
        <div className="title-container-screenshot">
          {<img className="title-image" src={Teams} alt="Upper"></img>}
          <p
            className="screenshot-screen-title section-title header-2"
            style={{ color: '#000000' }}
          >
            {'AI-Driven Apps for More Efficient Teams'}
          </p>
          {<img className="title-image" src={WhiteCircles} alt="Lower"></img>}
        </div>
        <div className="tab-container">
          <div className="segment-container">
            {SegmentLabels.map((label) => {
              return (
                <button
                  key={label}
                  className="segment-button button-small"
                  onClick={() => {
                    setActiveTab(label);
                  }}
                  style={
                    label !== activeTab
                      ? {
                          background: 'transparent',
                        }
                      : { background: 'white', fontWeight: 600 }
                  }
                >
                  <span className={`${label === activeTab && 'active-segment'}`}>{label}</span>
                </button>
              );
            })}
          </div>
          {TAB_ITEMS.find((item) => item.label === activeTab).content}
        </div>
      </section>
    </>
  );
}
